const TwoFactor = () => {
  return;
};

export default TwoFactor;
